angular.module('zc.projects')

.directive 'zcInterestWidgetTreeConfirm', ($filter, BaseProjectConfirm, InterestTree) ->
  confirm = new BaseProjectConfirm $filter('translate')('projectsSettings.other.interestWidgetTreeConfirm.iwInterestTree'), ['_id']
  confirm.createDirective (scope, elem, attrs) ->
    InterestTree.find
      apikey: scope.apikey
    ,
      match:
        name: 'random_forest_for_interest_widget_item'



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.settings/other/interest_widget_tree_confirm.directive.coffee